import { Reveal } from "./Reveal";
import { ChapterLabel } from "./ChapterLabel";
import { skillGroups, languages } from "../data/content";

export default function Skills() {
  return (
    <section id="skills" className="section-shell" data-testid="skills-section">
      <div className="container-x">
        <ChapterLabel index="04" title="Skills" />

        <div className="space-y-0 border-t border-hairline">
          {skillGroups.map((group, i) => (
            <Reveal key={group.label} delay={i * 0.05}>
              <div
                data-testid={`skill-group-${group.label.toLowerCase()}`}
                className="grid sm:grid-cols-[160px_1fr] gap-4 sm:gap-8 py-7 border-b border-hairline items-start"
              >
                <span className="font-mono text-xs uppercase tracking-[0.25em] text-teal pt-1.5">
                  {group.label}
                </span>
                <div className="flex flex-wrap gap-2">
                  {group.items.map((item) => (
                    <span
                      key={item}
                      className="text-sm text-body bg-panel border border-hairline px-3.5 py-1.5 hover:border-teal hover:text-teal transition-colors duration-300 cursor-default"
                    >
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.15}>
          <p className="mt-8 text-sm text-faint font-mono tracking-wide" data-testid="languages-line">
            Languages — {languages}
          </p>
        </Reveal>
      </div>
    </section>
  );
}
